import { lazy } from "react";
import type { Path } from "react-router-dom";
import { generatePath } from "react-router-dom";
import type { AppRouteObject } from "../../routes";

export type IdentityProviderImplicitFlowParams = { realm: string };

export const implicitFlowProviderId = "implicit-flow";

const AddImplicitFlow = lazy(() => import("../add/AddImplicitFlow"));

export const IdentityProviderImplicitFlowRoute: AppRouteObject = {
  path: "/:realm/identity-providers/implicit-flow/add",
  element: <AddImplicitFlow />,
  breadcrumb: (t) => t("identity-providers:addImplicitFlowProvider"),
  handle: {
    access: "manage-identity-providers",
  },
};

export const toIdentityProviderImplicitFlow = (
  params: IdentityProviderImplicitFlowParams,
): Partial<Path> => ({
  pathname: generatePath(IdentityProviderImplicitFlowRoute.path, params),
});
